<template>
    <div id="app"
         :class="bgTheme">
        <router-view />
    </div>
</template>

<script>
export default {
    data() {
        return {
            bgTheme: 'bg-teal'
        }
    },
    mounted() {
        this.getBgTheme();
    },
    methods: {
        setBg(bg) {
            window.localStorage.setItem('bg', bg);
            this.getBgTheme();
        },
        getBgTheme() {
            this.bgTheme = window.localStorage.getItem('bg') || this.bgTheme;
            return this.bgTheme;
        }
    }
}
</script>

<style lang="scss">
@import './assets/scss/style.scss';
</style>
